import { useRef, useEffect } from 'react';

const usePopState = (handler: any) => {
	if (import.meta.env.DEV) {
		if (typeof handler !== 'function' && handler != null) {
			throw new TypeError(
				`Expected \`handler\` to be of type \`function\` but received type \`${typeof handler}\``
			);
		}
	}
	const cb = useRef(handler);

	useEffect(() => {
		const onPopState = cb.current;
		window.addEventListener('popstate', onPopState);
		return () => {
			window.removeEventListener('popstate', onPopState);
		};
	}, []);
};

export default usePopState;
